import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../Util/requests"
import DataPicker from "../../Components/DataPicker"
import Header from "../../Components/Header"
import Input from "../../Components/Input"
import InputMasked from "../../Components/InputMasked"
import InputNumeric from "../../Components/InputNumeric"
import Menu from "../Menu"
import Footer from "../../Components/Footer"
import Titulo from "../../Components/Titulo"
import BillReceiveBordereau from "../BillReceiveBordereau"
import SearchAccount from "../Account/Search"
import SearchAccountPlan from "../AccountPlan/Search"
import SearchBordereauReceive from "./Search"
import image_add from "../../Images/Buttons/add.png"
import image_clean from "../../Images/Buttons/clean.png"
import image_loading from "../../Images/spinner.gif";
import image_previous from "../../Images/Buttons/previous.png"
import image_save from "../../Images/Buttons/save.png"
import image_search from "../../Images/Buttons/search.png"
import image_select from "../../Images/Buttons/select_circle.png"

const BordereauReceive = ({modeSearch, databaseType, databasePath, jsonCompany, jsonLogin, system, setReturn, height, width, logoff}) => {
  const [code, setCode] = useState("")
  const [openDate, setOpenDate] = useState("")
  const [deliveryDate, setDeliveryDate] = useState("")
  const [value, setValue] = useState("")

  const [accountCode, setAccountCode] = useState("")
  const [accountNumber, setAccountNumber] = useState("")
  const [accountOwner, setAccountOwner] = useState("")

  ////
  // Search bills // Buscar títulos
  ////
  const [emissionDateIni, setEmissionDateIni] = useState(null)
  const [emissionDateEnd, setEmissionDateEnd] = useState(null)
  const [releaseDateIni, setReleaseDateIni] = useState(null)
  const [releaseDateEnd, setReleaseDateEnd] = useState(null)
  const [dueDateIni, setDueDateIni] = useState(null)
  const [dueDateEnd, setDueDateEnd] = useState(null)

  const [documentTypeDescription, setDocumentTypeDescription] = useState("")
  const [documentTypeDescriptionSelected, setDocumentTypeDescriptionSelected] = useState("")
  const [resultDocumentType, setResultDocumentType] = useState({})
  const [resultDocumentTypeFilter, setResultDocumentTypeFilter] = useState({})

  const [accountPlanCodeSearch, setAccountPlanCodeSearch] = useState("")
  const [accountPlanNumberSearch, setAccountPlanNumberSearch] = useState("")
  const [accountPlanDescriptionSearch, setAccountPlanDescriptionSearch] = useState("")

  const [accountPlanDescription, setAccountPlanDescription] = useState("")
  const [accountPlanDescriptionSelected, setAccountPlanDescriptionSelected] = useState("")
  const [resultAccountPlan, setResultAccountPlan] = useState({})
  const [resultAccountPlanFilter, setResultAccountPlanFilter] = useState({})

  const [clientCorporateName, setClientCorporateName] = useState("")
  const [clientCorporateNameSelected, setClientCorporateNameSelected] = useState("")
  const [resultClient, setResultClient] = useState({})
  const [resultClientFilter, setResultClientFilter] = useState({})

  const [jBillReceive, setJBillReceive] = useState({ CODE: 0 })    

  ////
  // Insert // Inserir
  ////
  const [billReceiveFilter, setBillReceiveFilter] = useState(true)  
  const [billReceiveSelected, setBillReceiveSelected] = useState([])

  const [showMenu, setShowMenu] = useState(true)
  const [showSearch, setShowSearch] = useState(true)
  const [showChange, setShowChange] = useState(false)
  const [showCancel, setShowCancel] = useState(false)

  const [showAccount, setShowAccount] = useState(false)
  const [showAccountPlan, setShowAccountPlan] = useState(false)
  const [showAccountPlanSearch, setShowAccountPlanSearch] = useState(false)
  const [showClient, setShowClient] = useState(false)
  const [showDocumentType, setShowDocumentType] = useState(false)  

  const [loading, setLoading] = useState(null)
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {   
    if (showDocumentType){
      let arrDocumentType = []

      if (documentTypeDescription === ""){
        resultDocumentType.map(item => (
          arrDocumentType.push(item)
        ))
      }
      else{
        resultDocumentType.map(item => (
          (item.DESCRIPTION.indexOf(documentTypeDescription.toUpperCase()) !== -1) &&
            arrDocumentType.push(item)
        ))
      }
      setResultDocumentTypeFilter(arrDocumentType)
    }

    if (showAccountPlan){
      let arrAccountPlan = []

      if (accountPlanDescription === ""){
        resultAccountPlan.map(item => (
          arrAccountPlan.push(item)
        ))
      }
      else{
        resultAccountPlan.map(item => (
          (item.DESCRIPTION.indexOf(accountPlanDescription.toUpperCase()) !== -1) &&
            arrAccountPlan.push(item)
        ))
      }
      setResultAccountPlanFilter(arrAccountPlan)
    }

    if (showClient){
      let arrClient = []
  
      if (clientCorporateName === ""){
        resultClient.map(item => (
          arrClient.push(item)
        ))
      }
      else{
        resultClient.map(item => (
          (item.CORPORATE_NAME.indexOf(clientCorporateName.toUpperCase()) !== -1) &&
            arrClient.push(item)
        ))
      }
      setResultClientFilter(arrClient)
    }
  }, [documentTypeDescription, accountPlanDescription, clientCorporateName])

  const add = () => {
    if (!showChange){
      setShowSearch(false)
    }

    setShowSearch(false)

    setError("")
    setWarning("")
    
    setCode("")
    setOpenDate("")
    setValue("")
    setAccountCode("")
    setAccountNumber("")
    setAccountOwner("")

    setDocumentTypeDescription("")
    setAccountPlanDescriptionSelected("")
    setAccountPlanDescription("")
    setClientCorporateName("")
    setClientCorporateNameSelected("")

    let returnJson = []

    ////
    // Get Document Type information // Carrega as informações dos Tipos de Documento
    ////
    setLoading("Aguarde buscando as informações dos Tipos de Documentos...")
    setWarning("")
    setError("")

    let formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", "{\"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }}")
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "BILL_RECEIVE/SearchDocumentType", formData) 
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
      ", \"ERROR\": \"Não foi possível pesquisar os Tipos de Documentos. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setLoading("")
        setWarning("")
        setError(returnJson.ERROR)

        setShowSearch(true)
        return
      }

      let arrDocumentType = []
      returnJson.OBJECT &&
        returnJson.OBJECT.map(item => (
          arrDocumentType.push(item)
        ))
      setResultDocumentType(arrDocumentType)

      let arrDocumentTypeFilter = []
      returnJson.OBJECT &&
        returnJson.OBJECT.map(item => (
          arrDocumentTypeFilter.push(item)
        ))
      setResultDocumentTypeFilter(arrDocumentTypeFilter)

      ////
      // Get Account Plan information // Carrega as informações dos Planos de Conta
      ////
      setLoading("Aguarde buscando as informações dos Planos de Conta...")
      setWarning("")
      setError("")

      formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", "{\"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }}")
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.post(BASE_URL + "BILL_RECEIVE/SearchAccountPlan", formData) 
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível pesquisar os Planos de Conta. ("+ response +")\" }") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setLoading("")
          setWarning("")
          setError(returnJson.ERROR)

          setShowSearch(true)
          return
        }

        let arrAccountPlan = []
        returnJson.OBJECT &&
          returnJson.OBJECT.map(item => (
            arrAccountPlan.push(item)
          ))
        setResultAccountPlan(arrAccountPlan)

        let arrAccountPlanFilter = []
        returnJson.OBJECT &&
          returnJson.OBJECT.map(item => (
            arrAccountPlanFilter.push(item)
          ))
        setResultAccountPlanFilter(arrAccountPlanFilter)
      })

      ////
      // Get Client information // Carrega as informações dos Clientes
      ////
      setLoading("Aguarde buscando as informações dos Clientes...")
      setWarning("")
      setError("")

      formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", "{\"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }}")
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.post(BASE_URL + "BILL_RECEIVE/SearchClient", formData) 
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível pesquisar os Clientes. ("+ response +")\" }") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setLoading("")
          setWarning("")
          setError(returnJson.ERROR)

          setShowSearch(true)
          return
        }

        let arrClient = []
        returnJson.OBJECT &&
          returnJson.OBJECT.map(item => (
            arrClient.push(item)
          ))
        setResultClient(arrClient)

        let arrClientFilter = []
        returnJson.OBJECT &&
          returnJson.OBJECT.map(item => (
            arrClientFilter.push(item)
          ))
        setResultClientFilter(arrClientFilter)
        
        setShowChange(true)
        setLoading("")
      })
    })

    setShowChange(!showChange)
  }

  const addClient = () => {
    cleanClient()
    setShowClient(true)
  }

  const addAccountPlan = () => {  
    cleanAccountPlan()
    setShowAccountPlan(true)
  }

  const addDocumentType = () => {
    cleanDocumentType()
    setShowDocumentType(true)
  }

  const cleanAccount = () => {
    setAccountCode("")
    setAccountOwner("")
    setShowAccount(false)
  }

  const cleanAccountPlan = () => {
    resultAccountPlan.map(item => (
      item.MARKET = false
    ))

    setResultAccountPlanFilter(resultAccountPlan)

    setAccountPlanDescriptionSelected("")
    setAccountPlanDescription("")
    setShowAccountPlan(false)
  }

  const cleanAccountPlanSearch = () => {
    resultAccountPlan.map(item => (
      item.MARKET = false
    ))

    setAccountPlanDescriptionSearch("")
    setShowAccountPlan(false)
  }  

  const cleanBillReceive = () => {
    setEmissionDateIni(null)
    setEmissionDateEnd(null)
    setReleaseDateIni(null)
    setReleaseDateEnd(null)
    setDueDateIni(null)
    setDueDateEnd(null)

    setShowClient(false)
    setShowAccountPlan(false)
    setShowDocumentType(false)

    setClientCorporateName("")
    setClientCorporateNameSelected("")
    setResultClientFilter(resultClient)

    setDocumentTypeDescription("")
    setDocumentTypeDescriptionSelected("")
    setResultDocumentTypeFilter(resultDocumentType)
  
    setAccountPlanDescription("")
    setAccountPlanDescriptionSelected("")
    setResultAccountPlanFilter(resultAccountPlan)

    setJBillReceive({ CODE: 0 })

    setWarning("")
    setError("")
  }

  const cleanClient = () => {
    resultClient.map(item => (
      item.MARKET = false
    ))

    setResultClientFilter(resultClient)

    setClientCorporateNameSelected("")
    setClientCorporateName("")
    setShowClient(false)
  }

  const cleanDocumentType = () => {
    resultDocumentType.map(item => (
      item.MARKET = false
    ))

    setResultDocumentTypeFilter(resultDocumentType)

    setDocumentTypeDescriptionSelected("")
    setDocumentTypeDescription("")
    setShowDocumentType(false)
  }

  const fillAccount = (account) => {
    setAccountCode(account.ID)
    setAccountNumber(account.NUMBER)
    setAccountOwner(account.OWNER)  
    setShowAccount(false)
  }

  const fillAccountPlan = (accountPlan) => {
    setAccountPlanCodeSearch(accountPlan.ID)
    setAccountPlanNumberSearch(accountPlan.NUMBER)
    setAccountPlanDescriptionSearch(accountPlan.DESCRIPTION)
  
    setShowAccountPlanSearch(false)
  }    

  const formatNumeric = (value, decimals) => {
    if (!value) return "0.00"
    if (value === ".") return value = "0."

    const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimals}})?`)

    let decimalsNumber = 0
    try { decimalsNumber = value.toString().match(regex)[0] } catch { decimalsNumber = 0 }

    const parsed = parseFloat(decimalsNumber).toFixed(decimals)

    if (isNaN(parsed)) return "0.00"
    return parsed
  }

  const markAllAccountPlan = () => {
    let selected = ""

    resultAccountPlan.map(item => (
      (selected === "") ? selected = (item.ID + "-" + item.DESCRIPTION)
      : selected += ("," + item.ID + "-" + item.DESCRIPTION)
    ))
    
    setAccountPlanDescriptionSelected(selected)
    setShowAccountPlan(false)
  }

  const markAllClient = () => {
    let selected = ""

    resultClient.map(item => (
      (selected === "") ? selected = (item.CPF_CNPJ + "-" + item.CORPORATE_NAME)
      : selected += ("," + item.CPF_CNPJ + "-" + item.CORPORATE_NAME)
    ))
    
    setClientCorporateNameSelected(selected)
    setShowClient(false)
  }

  const markAllDocumentType = () => {
    let selected = ""

    resultDocumentType.map(item => (
      (selected === "") ? selected = (item.ID + "-" + item.DESCRIPTION)
      : selected += ("," + item.ID + "-" + item.DESCRIPTION)
    ))
    
    setDocumentTypeDescriptionSelected(selected)
    setShowDocumentType(false)
  }

  const returnAdd = () => {
    setWarning("")
    setError("")

    ////
    // Fields Bordereau // Campos Bordero
    ///
    setCode("")
    setOpenDate("")
    setDeliveryDate("")
    setValue("")
    setAccountCode("")
    setAccountNumber("")
    setAccountOwner("")
    setAccountPlanCodeSearch("")
    setAccountPlanNumberSearch("")
    setAccountPlanDescriptionSearch("")
    
    ////
    // Fields Search Bills //  Campos buscar títulos
    ////
    setDocumentTypeDescription("")
    setDocumentTypeDescriptionSelected("")
    setAccountPlanDescription("")
    setAccountPlanDescriptionSelected("")
    setClientCorporateName("")
    setClientCorporateNameSelected("")
    setEmissionDateIni(null)
    setEmissionDateEnd(null)
    setReleaseDateIni(null)
    setReleaseDateEnd(null)
    setDueDateIni(null)
    setDueDateEnd(null)

    setJBillReceive({ CODE: 0 })
    
    setBillReceiveFilter(true)
    setBillReceiveSelected([])
            
    setShowAccount(false)
    setShowAccountPlan(false)
        
    setShowSearch(true)
    setShowChange(false)
    setShowCancel(false)
  }

  const returnFilter = () => {
    let search = false

    if (documentTypeDescriptionSelected !== "") search = true
    if (!search) if (accountPlanDescriptionSelected !== "") search = true
    if (!search) if (clientCorporateNameSelected !== "") search = true
    if (!search) if (validateDate(emissionDateIni) && validateDate(emissionDateEnd)) search = true
    if (!search) if (validateDate(releaseDateIni) && validateDate(releaseDateEnd)) search = true
    if (!search) if (validateDate(dueDateIni) && validateDate(dueDateEnd)) search = true

    if (!search){
      setError("É necessário informar algum filtro para a pesquisa!")
      if (jBillReceive.CODE !== 0) setJBillReceive({ CODE: 0 })
    }        
    else        
    {            
      let jAccount = "{"
      jAccount += " \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }, \"SITUATION\": 99"
      if (documentTypeDescriptionSelected !== "") jAccount += ", \"DOCUMENT_TYPES\": \""+ documentTypeDescriptionSelected +"\""
      if (accountPlanDescriptionSelected !== "") jAccount += ", \"ACCOUNTS_PLAN\": \""+ accountPlanDescriptionSelected +"\""
      if (clientCorporateNameSelected !== "") jAccount += ", \"CLIENTS\": \""+ clientCorporateNameSelected +"\""      

      if (validateDate(emissionDateIni) && validateDate(emissionDateEnd)){
        const emissionI = emissionDateIni.toLocaleString()
        const emissionE = emissionDateEnd.toLocaleString()

        const emissionIni = String(emissionI).substr(6,4) + "-" + String(emissionI).substr(3,2) + "-" + String(emissionI).substr(0,2) + "T00:00:00"
        const emissionEnd = String(emissionE).substr(6,4) + "-" + String(emissionE).substr(3,2) + "-" + String(emissionE).substr(0,2) + "T23:59:59"
        jAccount += ", \"EMISSION_DATE_START\": \"" + emissionIni + "\", \"EMISSION_DATE_END\": \"" + emissionEnd + "\""
      }

      if (validateDate(releaseDateIni) && validateDate(releaseDateEnd)){
        const releaseI = releaseDateIni.toLocaleString()
        const releaseE = releaseDateEnd.toLocaleString()

        const releaseIni = String(releaseI).substr(6,4) + "-" + String(releaseI).substr(3,2) + "-" + String(releaseI).substr(0,2) + "T00:00:00"
        const releaseEnd = String(releaseE).substr(6,4) + "-" + String(releaseE).substr(3,2) + "-" + String(releaseE).substr(0,2) + "T23:59:59"
        jAccount += ", \"RELEASE_DATE_START\": \"" + releaseIni + "\", \"RELEASE_DATE_END\": \"" + releaseEnd + "\""
      }

      if (validateDate(dueDateIni) && validateDate(dueDateEnd)){
        const dueI = dueDateIni.toLocaleString()
        const dueF = dueDateEnd.toLocaleString()

        const dueIni = String(dueI).substr(6,4) + "-" + String(dueI).substr(3,2) + "-" + String(dueI).substr(0,2) + "T00:00:00"
        const dueFim = String(dueF).substr(6,4) + "-" + String(dueF).substr(3,2) + "-" + String(dueF).substr(0,2) + "T23:59:59"
        jAccount += ", \"DUE_DATE_START\": \"" + dueIni + "\", \"DUE_DATE_END\": \"" + dueFim + "\""
      }

      jAccount += " }"
      setJBillReceive(jAccount)
    }
  }  

  const reverseBillReceive = (bills) => {
    let returnJson = []
    let jsonBordereauReceive_New = {}

    setWarning("")
    setError("")

    if (bills.length === 0){
        alert("É necessário selecionar as contas a receber.")
        return
    }

    let aSelected = []
    bills.map(item => (
      item.MARKET && aSelected.push(item)
    ))

    if (aSelected.length === 0){
      alert("É necessário selecionar as contas a receber.")
      return
    }

    setLoading("Aguarde cancelando o registro...")

    const jsonBordereauReceiveCompany_New = " \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }"

    const jsonBordereauReceiveAccount_New = ", \"ACCOUNT\": { \"ID\": "+ accountCode +", \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }"+
      ", \"NUMBER\": \""+ accountNumber +"\", \"OWNER\": \""+ accountOwner +"\" }"

    const jsonBordereauReceiveEmployee_New = ", \"EMPLOYEE\": { \"ID\": "+ jsonLogin.ID +", \"NAME\": \""+ jsonLogin.NAME +"\" }"
    const openDat = openDate.substr(6,4) + "-" + openDate.substr(3,2) + "-" + openDate.substr(0,2) + "T00:00:00"
    
    let cancelDate = new Date();
    cancelDate = cancelDate.toLocaleDateString().substr(6,4) + "-" + cancelDate.toLocaleDateString().substr(3,2) + "-" + 
      cancelDate.toLocaleDateString().substr(0,2) + "T00:00:00"

    jsonBordereauReceive_New = "{ \"ID\": "+ code +", \"OPEN_DATE\": \""+ openDat +"\", \"CANCEL_DATE\": \""+ cancelDate +"\""+
      ", \"VALUE\": "+ value +", \"SITUATION\": 2, "+ jsonBordereauReceiveCompany_New + jsonBordereauReceiveAccount_New + 
        jsonBordereauReceiveEmployee_New + " }"

    const formData = new FormData();
    formData.append("DATABASE_TYPE", databaseType);
    formData.append("DATABASE_PATH", databasePath);
    formData.append("JSON_NEW_1", jsonBordereauReceive_New);
    formData.append("JSON_NEW_2", JSON.stringify(aSelected));
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin));
    formData.append("SYSTEM", system);

    axios.put(BASE_URL + "BORDEREAU_RECEIVE/Cancel", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
      ", \"ERROR\": \"Não foi possível cancelar o Bordero a Receber. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setWarning("")
        setLoading("")
        return
      }

      alert(returnJson.OBJECT)

      setLoading("")
      returnAdd()
    })
  }

  const save = (billReceiveSelected) => {
    let returnJson = []
    let jsonBordereauReceive_New = {}

    setWarning("")
    setError("")

    if (!validateDate(deliveryDate)){
      setError("É necessário informar a data do recebimento!")
      document.getElementById("bordereauReceiveDeliveryDate").focus()
      return                
    }

    if (accountCode === ""){
      setError("É necessário informar a conta!")
      return
    }

    if (jsonCompany.TYPE === 1)
    {
      if (accountPlanCodeSearch === ""){
        setError("É necessário selecionar o plano de contas.")
        return
      }
    }

    setLoading("Aguarde incluindo o registro...")

    const jsonBordereauReceiveCompany_New = " \"COMPANY\": { \"ID\": "+ jsonCompany.ID + "}"

    const jsonBordereauReceiveAccount_New = ", \"ACCOUNT\": { \"ID\": "+ accountCode +", \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }"+
      ", \"NUMBER\": \""+ accountNumber +"\", \"OWNER\": \""+ accountOwner +"\" }"

    const jsonBordereauReceiveEmployee_New = ", \"EMPLOYEE\": { \"ID\": "+ jsonLogin.ID +", \"NAME\": \""+ jsonLogin.NAME +"\" }"        

    let date  = new Date()
    date = date.toLocaleDateString().substr(6,4) + "-" + date.toLocaleDateString().substr(3,2) + "-" + date.toLocaleDateString().substr(0,2) + "T00:00:00"

    let deliveryDat = deliveryDate.toLocaleDateString()
    deliveryDat = deliveryDat.substr(6,4) + "-" + deliveryDat.substr(3,2) + "-" + deliveryDat.substr(0,2) + "T00:00:00"

    jsonBordereauReceive_New = "{ \"OPEN_DATE\": \""+ date +"\", \"DELIVERY_DATE\": \""+ deliveryDat +"\", \"SITUATION\": 1, "+ 
      jsonBordereauReceiveCompany_New + jsonBordereauReceiveAccount_New + jsonBordereauReceiveEmployee_New + " }"

    let jAccountPlan = "{ \"ID\": 0 }"
    if (setAccountPlanCodeSearch !== "") jAccountPlan = "{ \"ID\": "+ accountPlanCodeSearch +", \"NUMBER\": \""+ accountPlanNumberSearch +"\""+
      ", \"DESCRIPTION\": \""+ accountPlanDescriptionSearch +"\" }"    

    const formData = new FormData();
    formData.append("DATABASE_TYPE", databaseType);
    formData.append("DATABASE_PATH", databasePath);
    formData.append("JSON_NEW_1", jsonBordereauReceive_New);
    formData.append("JSON_NEW_2", JSON.stringify(billReceiveSelected));
    formData.append("JSON_NEW_3", jAccountPlan);
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin));
    formData.append("SISTEMA", system);
    formData.append("GET_ID", true);

    axios.post(BASE_URL + "BORDEREAU_RECEIVE/Insert", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
      ", \"ERROR\": \"Não foi possível incluir o Bordero a Receber. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setWarning("")
        setLoading("")
        return
      }

      alert(returnJson.OBJECT)

      setLoading("")
      returnAdd()
    })
  }

  const saveBillReceive = (bills) => {
    if (bills.length === 0){
      alert("É necessário selecionar as contas receber.")
      return
    }

    let aSelected = []
    bills.map(item => (
      item.MARKET && aSelected.push(item)
    ))

    if (aSelected.length === 0){
      alert("É necessário selecionar as contas receber.")
      return
    }

    setDeliveryDate(new Date())
    setBillReceiveSelected(aSelected)
    setBillReceiveFilter(false)
  }  

  const selected = (event) => {
    setShowSearch(false)
    setShowChange(true)
    setShowAccount(false)

    setCode(event.ID)

    const sOpenDate = event.OPEN_DATE.substr(8, 2) + "/" + event.OPEN_DATE.substr(5, 2) + "/" + event.OPEN_DATE.substr(0, 4)
    setOpenDate(sOpenDate)

    setValue(formatNumeric(event.VALUE, 2))
    setAccountCode(event.ACCOUNT.ID);
    setAccountNumber(event.ACCOUNT.NUMBER);
    setAccountOwner(event.ACCOUNT.OWNER);
  }   

  const selectAccountPlan = () => {
    setShowAccountPlan(false)
  }

  const selectClient = () => {
    setShowClient(false)
  }

  const selectDocumentType = () => {
    setShowDocumentType(false)
  }

  const setFieldSelected = () => {
  }

  const updateShowAccountPlan = (id) => {
    resultAccountPlan.map(item => (
      (item.ID === id) ? item.MARKET = !item.MARKET : ""
    ))

    let selected = ""
    resultAccountPlan.map(item => (
      (item.MARKET) ? (selected === "") ? selected = item.ID + "-" + item.DESCRIPTION
                       : selected = selected + "," + item.ID + "-" + item.DESCRIPTION
      : ""
    ))
    setAccountPlanDescriptionSelected(selected)
  }

  const updateShowClient = (id) => {
    resultClient.map(item => (
      (item.ID === id) ? item.MARKET = !item.MARKET : ""
    ))

    let selected = ""
    resultClient.map(item => (
      (item.MARKET) ? (selected === "") ? selected = item.CPF_CNPJ + "-" + item.CORPORATE_NAME
                       : selected = selected + "," + item.CPF_CNPJ + "-" + item.CORPORATE_NAME
      : ""
    ))
    setClientCorporateNameSelected(selected)
  }

  const updateShowDocumentType = (id) => {
    resultDocumentType.map(item => (
      (item.ID === id) ? item.MARKET = !item.MARKET : ""
    ))

    let selected = ""
    resultDocumentType.map(item => (
      (item.MARKET) ? (selected === "") ? selected = item.ID + "-" + item.DESCRIPTION
                       : selected = selected + "," + item.ID + "-" + item.DESCRIPTION
      : ""
    ))
    setDocumentTypeDescriptionSelected(selected)
  }

  const validateDate = (value) => {
    let error = false;
    let date = "";
    if ((value !== null) && (value !== "")) date = value.toLocaleString()

    let ardt = new Array([]);
    const ExpReg = new RegExp("(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}");
    ardt = date.split("/");        

    if (date.search(ExpReg)===-1) error = true
    else if (((ardt[1]===4)||(ardt[1]===6)||(ardt[1]===9)||(ardt[1]===11))&&(ardt[0]>30)) 
      error = true
    else if (ardt[1]===2) {
      if ((ardt[0]>28)&&((ardt[2]%4)!==0)) error = true;
      if ((ardt[0]>29)&&((ardt[2]%4)===0)) error = true;
    }

    if (error) return false;
    return true;
  }

  return(
    <div style={{display: "flex", flexDirection: "column", flexGrow: 1, minHeight: height}}>
      <div style={(width < 690) ? {display: "flex", flexGrow: 1, flexDirection: "column", marginBottom: 10}
        : {display: "flex", flexGrow: 1, flexDirection: "row", marginBottom: 10}}>

        { showMenu &&
          <div style={{display: "flex", flexGrow: 0}}>
            <Menu jsonCompany={jsonCompany} jsonLogin={jsonLogin} showMenu={showMenu} setShowMenu={setShowMenu} height={height} width={width}
              logoff={logoff} />
          </div>
        }

        <div style={{display: "flex", flexGrow: 1, flexDirection: "column"}}>
          <Header
            title="Bordero Conta a Receber"
            titleSearch="Pesquisa dos Borderos a Receber"
            showSearch={showSearch}
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            width={width} />

          { showSearch ?
              <SearchBordereauReceive
                modeSearch={modeSearch}
                databaseType={databaseType}
                databasePath={databasePath}
                jsonLogin={jsonLogin}
                jsonCompany={jsonCompany}
                system={system}
                setAdd={add}
                setSelected={selected}
                setReturn={setReturn}
                showMenu={showMenu}
                width={width} />
            :
              <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                { showChange &&
                  <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>

                    { loading ?
                        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "center", alignItems: "center"}}>
                          <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
                          <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
                        </div>
                      :
                        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>

                          { !showAccount && !showCancel && code &&
                            <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                              <div style={(width < 480) ? { paddingLeft: 10, paddingRight: 10} : { paddingLeft: 20, paddingRight: 20}}>
                                <div style={{display: "flex", flexGrow: 0, flexDirection: "row", paddingTop: 0, paddingRight: 10, paddingBottom: 0,
                                  paddingLeft: 10}}>
                                  { warning && 
                                    <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                      marginBottom: 10}}>
                                      <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                                    </div> 
                                  }

                                  { error &&
                                    <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                      marginBottom: 10}}>
                                      <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                                    </div>
                                  }
                                </div>

                                <div style={(showMenu) ?
                                    (width < 1520) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                    : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
                                  :
                                    (width < 1250) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                    : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>

                                  <div style={(showMenu) ?
                                      (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                      : (width < 1520) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0}
                                    :
                                      (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                      : (width < 1250) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                    <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}}>
                                      <InputMasked
                                        type="text"
                                        name="bordereauReceiveOpenDate"
                                        description="Data Abertura"
                                        mask="99/99/9999"
                                        value={openDate}
                                        disabled={false}
                                        require={true}
                                        image={false}
                                        typeInput={2}
                                        onSelect={setFieldSelected} />
                                    </div>
                                      
                                    <div style={(showMenu) ?
                                        (width < 450) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                        : (width < 1520) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 180, maxWidth: 180}
                                      :
                                        (width < 450) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                        : (width < 1250) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 180, maxWidth: 180}}>
                                      <InputNumeric
                                        type="text"
                                        name="bordereauReceiveValue"
                                        description="Valor"
                                        value={value || ""}
                                        maxLength={13}
                                        disabled={true}
                                        require={false}
                                        negative={false} 
                                        image={false}
                                        typeInput={2} 
                                        onSelect={setFieldSelected} />
                                    </div>
                                  </div>
                                  
                                  <div style={(showMenu) ?
                                      (width < 1160) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                      : (width < 1520) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}
                                    :
                                      (width < 890) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                      : (width < 1250) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>

                                    <div style={(showMenu) ?
                                        (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                        : (width < 1160) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                        : {display: "flex", flexDirection: "row", flexGrow: 0}
                                      :
                                        (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                        : (width < 890) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                        : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                      <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}}>
                                        <Input
                                          type="text"
                                          name="bordereauReceiveAccountCode"
                                          description="Código"
                                          value={accountCode}
                                          maxLength={11}
                                          disabled={true}
                                          require={false}
                                          image={false}
                                          typeInput={2} 
                                          onSelect={setFieldSelected} />
                                      </div>
                                      
                                      <div style={(showMenu) ?
                                          (width < 450) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                          : (width < 1160) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                          : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 160, maxWidth: 160}
                                        :
                                          (width < 450) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                          : (width < 890) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                          : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 160, maxWidth: 160}}>
                                        <Input
                                          type="text"
                                          name="bordereauReceiveAccountNumber"
                                          description="Número"
                                          value={accountNumber}
                                          maxLength={10}
                                          disabled={true}
                                          require={false}
                                          image={false}
                                          typeInput={2}
                                          onSelect={setFieldSelected} />
                                      </div>
                                    </div>
                                    
                                    <div style={(showMenu) ?
                                        (width < 1160) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                        : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                      :
                                        (width < 890) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                        : {display: "flex",  flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                      <Input
                                        type="text"
                                        name="bordereauReceiveAccountOwner"
                                        description="Titular"
                                        value={accountOwner}
                                        maxLength={50}
                                        disabled={true}
                                        require={false}
                                        image={false}
                                        typeInput={2} 
                                        onSelect={setFieldSelected} />
                                    </div>
                                  </div>
                                </div>

                                <BillReceiveBordereau
                                  databaseType={databaseType}
                                  databasePath={databasePath}
                                  jsonCompany={jsonCompany}
                                  jsonLogin={jsonLogin}
                                  system={system}
                                  jBillReceive={"{ \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" }, \"BORDEREAU_RECEIVE\": { \"ID\": "+ code +" } }"}
                                  saveBillReceive={saveBillReceive}
                                  reverseBillReceive={reverseBillReceive}
                                  returnBordereau={returnAdd} 
                                  newBordereau={false} 
                                  width={width}
                                  showMenu={showMenu} />
                              </div>
                            </div>
                          }

                          { !showAccount && !showAccountPlanSearch && !billReceiveFilter && !code &&
                            <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                              <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                                <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10,
                                  marginLeft: 5, width: 147}} onClick={() => save(billReceiveSelected)}>
                                  <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                    paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                    <img style={{height: 32, width: 32}} src={image_save} alt="Salvar"/>
                                  </div>
                                  <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                    <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
                                  </div>
                                </div>

                                <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10, 
                                  marginLeft: 5, width: 147}} onClick={() => returnAdd()}>
                                  <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, paddingRight: 10,                                  
                                    paddingBottom: 5, paddingLeft: 10}}>
                                    <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                                  </div>
                                  <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                    <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                                  </div>
                                </div>
                              </div>

                              <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                              </div>

                              <div style={(width < 480) ? { paddingLeft: 10, paddingRight: 10} : { paddingLeft: 20, paddingRight: 20}}>
                                <div style={{display: "flex", flexGrow: 0, flexDirection: "row", paddingTop: 0, paddingRight: 10, paddingBottom: 0,
                                  paddingLeft: 10}}>
                                  { warning && 
                                    <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                      marginBottom: 10}}>
                                      <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                                    </div> 
                                  }

                                  { error &&
                                    <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                      marginBottom: 10}}>
                                      <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                                    </div>
                                  }
                                </div>
                              </div>

                              <div style={{paddingLeft: 10, paddingRight: 10, marginTop: 10}}>
                                <div style={(width < 450) ? {paddingLeft: 0, paddingRight: 0} : {paddingLeft: 10, paddingRight: 10}}> 
                                  <div>
                                    <Titulo description="Contas a receber selecionadas" />
                                  </div>

                                  { billReceiveSelected && (billReceiveSelected.length > 0) &&
                                    <div style={{display: "flex", flexDirection: "row", flexGrow: 1, borderBottomColor: "black", borderBottomWidth: 2, 
                                      borderBottomStyle: "solid", marginTop: 30, marginBottom: 4}}>

                                      <div style={(showMenu) ? 
                                          (width < 2170) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}
                                        : 
                                          (width < 1910) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                        <div style={showMenu ?
                                            (width < 1310) ?{display: "flex", flexDirection: "column", flexGrow: 1}
                                            : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}
                                          :
                                            (width < 1030) ?{display: "flex", flexDirection: "column", flexGrow: 1}
                                            : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                          <div style={showMenu ?
                                              (width < 1050) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}
                                            :
                                              (width < 780) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={{display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 5}}>
                                              <div style={showMenu ?
                                                  (width < 1050) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", marginLeft: 15, minWidth: 180}
                                                  : (width < 1310) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 500}
                                                  : (width < 2170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 500}
                                                  : {display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 500, maxWidth: 500}
                                                :
                                                  (width < 780) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", marginLeft: 10, minWidth: 180}
                                                  : (width < 1910) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 500}
                                                  : {display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 500, maxWidth: 500}}>
                                                <label style={{fontWeight: 600}}>Número/Parcela</label>
                                              </div>
                                            </div>

                                            <div style={showMenu ?
                                                (width < 1050) ? {display: "flex", flexGrow: 1, marginLeft: 20, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 90, maxWidth: 90}
                                              :
                                                (width < 780) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 90, maxWidth: 90}}>
                                              <label style={{fontWeight: 600}}>Vencto.</label>
                                            </div>
                                          </div>

                                          <div style={showMenu ?
                                              (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                              : (width < 1310) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}
                                            :
                                              (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                              : (width < 1030) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>

                                            <div style={showMenu ?
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 5}
                                                : (width < 1310) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 110, marginLeft: 5}
                                                : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                              :
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : (width < 1030) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                              <label style={{fontWeight: 600}}>Valor</label>
                                            </div>

                                            <div style={showMenu ?
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 110, marginLeft: 5}
                                                : (width < 1310) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, marginRight: 5, minWidth: 110, maxWidth: 110}
                                              :
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 110}
                                                : (width < 1030) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, marginRight: 5, minWidth: 110, maxWidth: 110}}>
                                              <label style={{fontWeight: 600}}>Recebido</label>
                                            </div>
                                          </div>
                                        </div>

                                        <div style={showMenu ?
                                            (width < 1310) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 20}
                                            : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 20}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}
                                          :
                                            (width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                            : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>

                                          <div style={showMenu ?
                                              (width < 1310) ?{display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: -5, minWidth: 430}
                                            :
                                              (width < 1030) ?{display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : (width < 1910) ? {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", minWidth: 430}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: -5, minWidth: 430}}>
                                            <label style={{fontWeight: 600}}>Cliente</label>
                                          </div>
                                          <div style={showMenu ?
                                              (width < 1310) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: 5, minWidth: 430}
                                            :
                                              (width < 1030) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: 5, minWidth: 430}}>
                                            <label style={{fontWeight: 600}}>Plano Conta</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  { billReceiveSelected && billReceiveSelected.map(item => (
                                    <div key={item.ID} style={{display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}}>

                                      <div style={(showMenu) ? 
                                          (width < 2170) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}
                                        : 
                                          (width < 1910) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                        <div style={showMenu ?
                                            (width < 1310) ?{display: "flex", flexDirection: "column", flexGrow: 1}
                                            : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}
                                          :
                                            (width < 1030) ?{display: "flex", flexDirection: "column", flexGrow: 1}
                                            : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                          <div style={showMenu ?
                                              (width < 1050) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}
                                            :
                                              (width < 780) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={{display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 5}}>
                                              <div style={showMenu ?
                                                  (width < 1050) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", marginLeft: 10, minWidth: 180}
                                                  : (width < 2170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 500}
                                                  : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 500, maxWidth: 500}
                                                :
                                                  (width < 780) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", marginLeft: 10, minWidth: 180}
                                                  : (width < 1910) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 500}
                                                  : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 500, maxWidth: 500}}>
                                                <label>{item.NUMBER + "/" + item.PORTION}</label>
                                              </div>
                                            </div>

                                            <div style={showMenu ?
                                                (width < 1050) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 90, maxWidth: 90}
                                              :
                                                (width < 780) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 90, maxWidth: 90}}>
                                              <label>{String(item.DUE_DATE).substr(8,2) + "/" + String(item.DUE_DATE).substr(5,2) + "/" + 
                                                String(item.DUE_DATE).substr(0,4)}</label>
                                            </div>
                                          </div>

                                          <div style={showMenu ?
                                              (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                              : (width < 1310) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}
                                            :
                                              (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                              : (width < 1030) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>

                                            <div style={showMenu ?
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : (width < 1310) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                              :
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : (width < 1030) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                              <label>{formatNumeric(item.VALUE,2)}</label>
                                            </div>

                                            <div style={showMenu ?
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 110}
                                                : (width < 1310) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}
                                              :
                                                (width < 450) ? {display: "flex", flexGrow: 1, minWidth: 110}
                                                : (width < 1030) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 110}
                                                : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 110, maxWidth: 110}}>
                                              <label>{item.VALUE_RECEIVED !== 0 ? formatNumeric(item.VALUE_RECEIVED,2) : "0.00"}</label>
                                            </div>
                                          </div>
                                        </div>

                                        <div style={showMenu ?
                                            (width < 1310) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                            : (width < 2170) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}
                                          :
                                            (width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 15}
                                            : (width < 1910) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 15}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>

                                          <div style={showMenu ?
                                              (width < 1310) ?{display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", minWidth: 430}
                                            :
                                              (width < 1030) ?{display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", minWidth: 430}}>
                                            <label>{item.CLIENT && item.CLIENT.CORPORATE_NAME}</label>
                                          </div>
                                          <div style={showMenu ?
                                              (width < 1310) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: 10, minWidth: 430}
                                            :
                                              (width < 1030) ? {display: "flex", flexGrow: 1, wordWrap: "break-word", minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, wordWrap: "break-word", marginLeft: 10, minWidth: 430}}>
                                            <label>{item.ACCOUNT_PLAN && item.ACCOUNT_PLAN.DESCRIPTION}</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    ))
                                  }

                                  <div style={showMenu ?
                                      (width < 1180) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
                                    :
                                      (width < 910) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>

                                    <div style={showMenu ?
                                        (width < 1180) ? {display: "flex", flexGrow: 0, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, alignItems: "end", minWidth: 140, maxWidth: 140}
                                      :
                                        (width < 910) ? {display: "flex", flexGrow: 0, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, alignItems: "end", minWidth: 140, maxWidth: 140}}>
                                      <DataPicker
                                        name="bordereauReceiveDeliveryDate"
                                        description="Data Recebto."
                                        value={deliveryDate}
                                        require={false}
                                        onSelect={setFieldSelected}
                                        onChange={(event) => setDeliveryDate(event)} 
                                        intervalo={true}
                                        inicial={true} />
                                    </div>

                                    <div style={showMenu ?
                                        (width < 1180) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                        : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}
                                      :
                                        (width < 910) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                                        : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                                        <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                          <b>Conta:</b>
                                        </div>

                                        <div style={showMenu ?
                                            (width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1}
                                          :
                                            (width < 760) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                            : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                          <div style={showMenu ?
                                              (width < 920) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 1}
                                            :
                                              (width < 660) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                            <div style={showMenu ?
                                                (width < 920) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}
                                              :
                                                (width < 660) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}}>
                                              <Input
                                                type="text"
                                                name="bordereauReceiveAccountNumber"
                                                description="Número"
                                                value={accountNumber}
                                                maxLength={10}
                                                disabled={true}
                                                require={true}
                                                image={false}
                                                typeInput={2} 
                                                onSelect={setFieldSelected} />
                                            </div>
                                            <div style={showMenu ?
                                                (width < 920) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                              :
                                                (width < 660) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                              <Input
                                                type="text"
                                                name="bordereauReceiveAccountOwner"
                                                description="Titular"
                                                value={accountOwner}
                                                maxLength={50}
                                                disabled={true}
                                                require={true}
                                                image={false}
                                                typeInput={2} 
                                                onSelect={setFieldSelected} />
                                            </div>
                                          </div>

                                          <div style={(showMenu) ? 
                                              (width < 1030) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}
                                            : 
                                              (width < 760) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                              onClick={() => setShowAccount(true)}>
                                              <img style={{height: 42, width: 42}} src={image_search} alt="Pesquisar"/>
                                            </div>
                                            <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} onClick={cleanAccount}>
                                              <img style={{height: 42, width: 42}} src={image_clean} alt="Limpar"/>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  { jsonCompany.TYPE === 1 &&
                                    <div style={{marginTop: 10}}>
                                      <div style={showMenu ?
                                          (width < 1180) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}
                                        :
                                          (width < 910) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                                        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                                          <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                            <b>Plano de Conta:</b>
                                          </div>

                                          <div style={showMenu ?
                                              (width < 1080) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 1}
                                            :
                                              (width < 810) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                              : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                            <div style={showMenu ?
                                                (width < 1080) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, minWidth: 250, maxWidth: 250}
                                              :
                                                (width < 810) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                : {display: "flex", flexGrow: 0, minWidth: 250, maxWidth: 250}}>
                                            <Input
                                              type="text"
                                              name="numeroPlanoContaPesquisa"
                                              description="Número"
                                              value={accountPlanNumberSearch}
                                              maxLength={50}
                                              disabled={true}
                                              require={true}
                                              image={false}
                                              typeInput={2} 
                                              onSelect={setFieldSelected} />
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1080) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                              :
                                                (width < 810) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                                            <Input
                                              type="text"
                                              name="descricaoPlanoContaPesquisa"
                                              description="Descrição"
                                              value={accountPlanDescriptionSearch}
                                              maxLength={255}
                                              disabled={true}
                                              require={true}
                                              image={false}
                                              typeInput={2} 
                                              onSelect={setFieldSelected} />
                                            </div>
                                          </div>
                                        </div>
                                        <div style={(showMenu) ? 
                                            (width < 1180) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}
                                          : 
                                            (width < 910) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                            onClick={() => setShowAccountPlanSearch(true)}>
                                            <img style={{height: 42, width: 42}} src={image_search} alt="Pesquisar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} onClick={cleanAccountPlanSearch}>
                                            <img style={{height: 42, width: 42}} src={image_clean} alt="Limpar"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div> 
                            </div>
                          }

                          { !showAccount && billReceiveFilter && !code &&
                            <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                              <div style={{marginTop: 10}}>
                                <Titulo description="Pesquisa das Contas a Receber" />
                              </div>

                              <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                                <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                                  <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10,
                                    marginLeft: 5, width: 147}} onClick={() => returnFilter()}>
                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                      paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                      <img style={{height: 32, width: 32}} src={image_search} alt="Pesquisar"/>
                                    </div>
                                    <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                      <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Pesquisar</label>
                                    </div>
                                  </div>

                                  <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10,
                                    marginLeft: 5, width: 147}} onClick={() => cleanBillReceive()}>
                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                      paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                      <img style={{height: 32, width: 32}} src={image_clean} alt="Limpar"/>
                                    </div>
                                    <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                      <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Limpar</label>
                                    </div>
                                  </div>

                                  <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10,
                                    marginLeft: 5, width: 147}} onClick={() => returnAdd()}>
                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                      paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                      <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                                    </div>
                                    <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                      <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                                    </div>
                                  </div>
                                </div>

                                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                  <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                                </div>

                                <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                                  <div style={{display: "flex", flexGrow: 0, flexDirection: "row", paddingTop: 0, paddingRight: 10, paddingBottom: 0,
                                    paddingLeft: 10}}>
                                    { warning && 
                                      <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                        marginBottom: 10}}>
                                        <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                                      </div> 
                                    }

                                    { error &&
                                      <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                                        marginBottom: 10}}>
                                        <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                                      </div>
                                    }
                                  </div>

                                  <div style={showMenu ?
                                      (width < 930) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
                                    :
                                      (width < 660) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                                    <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                      <Input
                                        type="search"
                                        name="bordereauReceiveClientCorporateNameSelected"
                                        description="Clientes Selecionados"
                                        value={clientCorporateNameSelected}
                                        maxLength={6000}
                                        disabled={true}
                                        require={false}
                                        image={false}
                                        typeInput={2}
                                        onSelect={setFieldSelected} />
                                    </div>

                                    <div style={(showMenu) ? 
                                        (width < 930) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                        : {display: "flex", flexDirection: "row", flexGrow: 0}
                                      : 
                                        (width < 660) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                        : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                      <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} onClick={(() => { addClient() })}>
                                        <img style={{height: 42, width: 42}} src={image_add} alt="Adicionar"/>
                                      </div>
                                      <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} onClick={(() => { cleanClient() })}>
                                        <img style={{height: 42, width: 42}} src={image_clean} alt="Limpar"/>
                                      </div>
                                    </div>
                                  </div>

                                  { showClient &&
                                    <div style={{display: "flex", flexGrow: 0, flexDirection: "column", marginTop: 10}}>
                                      <div style={{display: "flex", flexGrow: 0}}>
                                        <div style={{width: "100%"}}>
                                          <Titulo description="Cliente" />
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                        marginTop: 10, 
                                          marginLeft: 5, width: 210}} onClick={() => selectClient()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => markAllClient()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar Todos"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar Todos</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => cleanClient()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_clean} alt="Limpar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Limpar</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <div style={{display: "flex", flexGrow: 1, backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10}} />
                                      </div>

                                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                                        <div style={{display: "flex", flexGrow: 1, marginTop: 10}}>
                                          <Input
                                            type="search"
                                            name="searchBillReceiveClientCorporateName"
                                            description="Nome/Razão"
                                            value={clientCorporateName}
                                            maxLength={500}
                                            disabled={false}
                                            require={false}
                                            image={false}
                                            typeInput={2}
                                            onSelect={setFieldSelected}
                                            onChange={(event) => setClientCorporateName(event.target.value)} />
                                        </div>

                                        { resultClientFilter && (resultClientFilter.length > 0) &&
                                          <div style={(showMenu) ?
                                              (width < 1170) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 5}
                                              :
                                                {display: "flex", flexDirection: "row", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 4}
                                            :
                                              (width < 900) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 5}
                                              :
                                                {display: "flex", flexDirection: "row", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 4}}>

                                            <div style={(showMenu) ? 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : (width < 720) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 1170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={(showMenu) ? 
                                                  (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                                  : (width < 720) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}
                                                : 
                                                  (width < 480) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                                <div style={{display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 50, maxWidth: 50}} />

                                                <div style={showMenu ?
                                                    (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                    : (width < 720) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                  :
                                                    (width < 480) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                  <label style={{fontWeight: 600}}>Código</label>
                                                </div>
                                              </div>
                                              <div style={showMenu ?
                                                  (width < 480) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 1170) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}
                                                :  
                                                  (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 900) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}}>
                                                <label style={{fontWeight: 600}}>CPF/CNPJ</label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 900) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label style={{fontWeight: 600}}>Nome/Razão Social</label>
                                            </div>
                                          </div>
                                        }

                                        { resultClientFilter && resultClientFilter.map(item => (
                                          <div key={item.CPF_CNPJ + "_" + item.CORPORATE_NAME} style={showMenu ?
                                              (width < 1170) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                            :
                                              (width < 900) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}}>

                                            <div style={(showMenu) ? 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : (width < 720) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 1170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={(showMenu) ? 
                                                  (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                                  : (width < 720) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}
                                                : 
                                                  (width < 480) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                                <div style={{display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 50, maxWidth: 50}}>
                                                  <input type="checkbox" checked={item.MARKET} onChange={ () => updateShowClient(item.ID) } />
                                                </div>

                                                <div style={showMenu ?
                                                    (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                    : (width < 720) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                  :
                                                    (width < 480) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                  <label>{item.ID}</label>
                                                </div>
                                              </div>
                                              <div style={showMenu ?
                                                  (width < 480) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 1170) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}
                                                :  
                                                  (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 900) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}}>
                                                <label>
                                                  { item.CPF_CNPJ.length === 11 &&
                                                    item.CPF_CNPJ.substr(0,3) + "." + item.CPF_CNPJ.substr(4,3) + "." + item.CPF_CNPJ.substr(6,3) + "-" + 
                                                      item.CPF_CNPJ.substr(9,2)
                                                  }

                                                  { item.CPF_CNPJ.length === 14 &&
                                                    item.CPF_CNPJ.substr(0,2) + "." + item.CPF_CNPJ.substr(2,3) + "." + item.CPF_CNPJ.substr(5,3) + "/" + 
                                                      item.CPF_CNPJ.substr(8,4) + "-" + item.CPF_CNPJ.substr(12,4)
                                                  }
                                                </label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 900) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label>
                                                {item.CORPORATE_NAME}
                                              </label>
                                            </div>
                                          </div>
                                          ))
                                        }

                                        { resultClientFilter && (resultClientFilter.length === 0) &&
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10}}>
                                            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                                          </div>
                                        }

                                      </div>
                                    </div>
                                  }

                                  <div style={(showMenu) ?
                                      (width < 1540) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
                                    : 
                                      (width < 1260) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>

                                    <div style={showMenu ?
                                        (width < 930) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                        : (width < 1540) ? {display: "flex", flexGrow: 1, flexDirection: "row"}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row", flexBasis: 1}
                                      :
                                        (width < 660) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                        : (width < 1260) ? {display: "flex", flexGrow: 1, flexDirection: "row"}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row", flexBasis: 1}}>

                                      <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                        <Input
                                            type="search"
                                            name="bordereauReceiveDocumentTypeDescriptionSelected"
                                            description="Tipos de Documentos Selecionados"
                                            value={documentTypeDescriptionSelected}
                                            maxLength={6000}
                                            disabled={false}
                                            require={false}
                                            image={false}
                                            typeInput={2} 
                                            onSelect={setFieldSelected} />
                                      </div>

                                      <div style={(showMenu) ? 
                                          (width < 930) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}
                                        : 
                                          (width < 660) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                        <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                          onClick={(() => { addDocumentType() })}>
                                          <img style={{height: 42, width: 42}} src={image_add} alt="Adicionar"/>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                          onClick={(() => { cleanDocumentType() })}>
                                          <img style={{height: 42, width: 42}} src={image_clean} alt="Limpar"/>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={showMenu ?
                                        (width < 930) ? {display: "flex", flexGrow: 1, flexDirection: "column", marginTop: 10}
                                        : (width < 1540) ? {display: "flex", flexGrow: 1, flexDirection: "row", marginTop: 10}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row", flexBasis: 1, marginLeft: 10}
                                      :
                                        (width < 660) ? {display: "flex", flexGrow: 1, flexDirection: "column", marginTop: 10}
                                        : (width < 1260) ? {display: "flex", flexGrow: 1, flexDirection: "row", marginTop: 10}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row", flexBasis: 1, marginLeft: 10}}>

                                      <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                        <Input
                                          type="search"
                                          name="bordereauReceiveAccountPlanDescriptionSelected"
                                          description="Plano de Contas Selecionados"
                                          value={accountPlanDescriptionSelected}
                                          maxLength={6000}
                                          disabled={true}
                                          require={false}
                                          image={false}
                                          typeInput={2}
                                          onSelect={setFieldSelected} />
                                      </div>

                                      <div style={(showMenu) ? 
                                          (width < 930) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}
                                        : 
                                          (width < 660) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                        <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                          onClick={(() => { addAccountPlan() })}>
                                          <img style={{height: 42, width: 42}} src={image_add} alt="Adicionar"/>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}} 
                                          onClick={(() => { cleanAccountPlan() })}>
                                          <img style={{height: 42, width: 42}} src={image_clean} alt="Limpar"/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  { showDocumentType &&
                                    <div style={{display: "flex", flexGrow: 0, flexDirection: "column", marginTop: 10}}>
                                      <div style={{display: "flex", flexGrow: 0}}>
                                        <div style={{width: "100%"}}>
                                          <Titulo description="Tipo do Documento" />
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => selectDocumentType()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5,
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => markAllDocumentType()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar Todos"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar Todos</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => cleanDocumentType()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_clean} alt="Limpar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Limpar</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <div style={{display: "flex", flexGrow: 1, backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10}} />
                                      </div>

                                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                                        <div style={{display: "flex", flexGrow: 1, marginTop: 10}}>
                                          <Input
                                            type="search"
                                            name="searchBillReceiveDocumentTypeDescription"
                                            description="Descrição"
                                            value={documentTypeDescription}
                                            maxLength={500}
                                            disabled={false}
                                            require={false}
                                            image={false}
                                            typeInput={2}
                                            onSelect={setFieldSelected}
                                            onChange={(event) => setDocumentTypeDescription(event.target.value)} />
                                        </div>

                                        { resultDocumentTypeFilter && (resultDocumentTypeFilter.length > 0) &&
                                          <div style={(showMenu) ?
                                              (width < 1030) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 5}
                                              :
                                                {display: "flex", flexDirection: "row", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 4}
                                            :
                                              (width < 760) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 5}
                                              :
                                                {display: "flex", flexDirection: "row", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 4}}>

                                            <div style={(showMenu) ? 
                                                (width < 1030) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 760) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={{display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 50, maxWidth: 50}} />

                                              <div style={showMenu ?
                                                  (width < 1030) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                :
                                                  (width < 760) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                <label style={{fontWeight: 600}}>Código</label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1030) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 760) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label style={{fontWeight: 600}}>Descrição</label>
                                            </div>
                                          </div>
                                        }

                                        { resultDocumentTypeFilter && resultDocumentTypeFilter.map(item => (
                                          <div key={item.ID + "_" + item.DESCRIPTION} style={showMenu ?
                                              (width < 1030) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                            :
                                              (width < 760) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                  borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                  marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}}>

                                            <div style={(showMenu) ? 
                                                (width < 1030) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 760) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={{display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 50, maxWidth: 50}}>
                                                <input type="checkbox" checked={item.MARKET} onChange={ () => updateShowDocumentType(item.ID) } />
                                              </div>

                                              <div style={showMenu ?
                                                  (width < 1030) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                :
                                                  (width < 760) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                <label>{item.ID}</label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1030) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 760) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label>
                                                {item.DESCRIPTION}
                                              </label>
                                            </div>
                                          </div>
                                          ))
                                        }
                                          
                                        { resultDocumentTypeFilter && (resultDocumentTypeFilter.length === 0) &&
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10}}>
                                            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                                          </div>
                                        }

                                      </div>
                                    </div>
                                  }

                                  { showAccountPlan &&
                                    <div style={{display: "flex", flexGrow: 0, flexDirection: "column", marginTop: 10}}>
                                      <div style={{display: "flex", flexGrow: 0}}>
                                        <div style={{width: "100%"}}>
                                          <Titulo description="Plano de Conta" />
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => selectAccountPlan()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => markAllAccountPlan()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_select} alt="Selecionar Todos"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Selecionar Todos</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5,
                                          marginTop: 10, marginLeft: 5, width: 210}} onClick={() => cleanAccountPlan()}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                                            <img style={{height: 32, width: 32}} src={image_clean} alt="Limpar"/>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Limpar</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <div style={{display: "flex", flexGrow: 1, backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10}} />
                                      </div>

                                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5} : {paddingLeft: 10, paddingRight: 10}}>
                                        <div style={{display: "flex", flexGrow: 1, marginTop: 10}}>
                                          <Input
                                            type="search"
                                            name="searchBillReceiveAccountPlanDescription"
                                            description="Descrição"
                                            value={accountPlanDescription}
                                            maxLength={500}
                                            disabled={false}
                                            require={false}
                                            image={false}
                                            typeInput={2}
                                            onSelect={setFieldSelected}
                                            onChange={(event) => setAccountPlanDescription(event.target.value)} />
                                        </div>

                                        { resultAccountPlanFilter && (resultAccountPlanFilter.length > 0) &&
                                          <div style={(showMenu) ?
                                            (width < 1170) ?
                                              {display: "flex", flexDirection: "column", flexGrow: 1,
                                                borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                marginTop: 30, marginBottom: 5}
                                            :
                                              {display: "flex", flexDirection: "row", flexGrow: 1,
                                                borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                marginTop: 30, marginBottom: 4}
                                            :
                                              (width < 900) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 5}
                                              :
                                                {display: "flex", flexDirection: "row", flexGrow: 1,
                                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                                  marginTop: 30, marginBottom: 4}}>

                                            <div style={(showMenu) ? 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : (width < 720) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 1170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={(showMenu) ? 
                                                  (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                                  : (width < 720) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}
                                                : 
                                                  (width < 480) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                                <div style={{display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 50, maxWidth: 50}} />

                                                <div style={showMenu ?
                                                    (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                    : (width < 720) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                  :
                                                    (width < 480) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                  <label style={{fontWeight: 600}}>Código</label>
                                                </div>
                                              </div>
                                              <div style={showMenu ?
                                                  (width < 480) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 1170) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}
                                                :  
                                                  (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 900) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}}>
                                                <label style={{fontWeight: 600}}>Número</label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 900) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label style={{fontWeight: 600}}>Descrição</label>
                                            </div>
                                          </div>
                                        }

                                        { resultAccountPlanFilter && resultAccountPlanFilter.map(item => (
                                          <div key={item.ID + "_" + item.NUMBER + "_" + item.DESCRIPTION} style={showMenu ?
                                              (width < 1170) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                            :
                                              (width < 900) ?
                                                {display: "flex", flexDirection: "column", flexGrow: 1,
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}
                                              : 
                                                {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                                backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                                borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                                marginTop: 4, minWidth: 180}}>

                                            <div style={(showMenu) ? 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : (width < 720) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 1170) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}
                                              : 
                                                (width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                                : (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                              <div style={(showMenu) ? 
                                                  (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                                                  : (width < 720) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}
                                                : 
                                                  (width < 480) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                                                  : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                                <div style={{display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 50, maxWidth: 50}}>
                                                  <input type="checkbox" checked={item.MARKET} onChange={ () => updateShowAccountPlan(item.ID) } />
                                                </div>

                                                <div style={showMenu ?
                                                    (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                    : (width < 720) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}
                                                  :
                                                    (width < 480) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                    : {display: "flex", flexGrow: 0, minWidth: 110, maxWidth: 110}}>
                                                  <label>{item.ID}</label>
                                                </div>
                                              </div>
                                              <div style={showMenu ?
                                                  (width < 480) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 1170) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}
                                                :  
                                                  (width < 720) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                  : (width < 900) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                                  : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}}>
                                                <label>{item.NUMBER}</label>
                                              </div>
                                            </div>
                                            <div style={showMenu ?
                                                (width < 1170) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}
                                              :
                                                (width < 900) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
                                                : {display: "flex", flexGrow: 1, minWidth: 180}}>
                                              <label>{item.DESCRIPTION}</label>
                                            </div>
                                          </div>
                                          ))
                                        }

                                        { resultAccountPlanFilter && (resultAccountPlanFilter.length === 0) &&
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10}}>
                                            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                                          </div>
                                        }

                                      </div>
                                    </div>
                                  }

                                  { showMenu && (width <= 1380) &&
                                    <div style={{display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}}>
                                      <div style={
                                        (width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                        : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                        <div style={(width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1}}>

                                          <b>Data Emissão</b>
                                          <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveEmissionDateIni"
                                                description="Inicial"
                                                value={emissionDateIni}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setEmissionDateIni(event)} 
                                                intervalo={true}
                                                inicial={true}
                                                endDate={emissionDateEnd} />
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                                marginTop: 10, minWidth: 25}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                                marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                              <label style={{fontWeight: 600}}>à</label>
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveEmissionDateEnd"
                                                description="Final"
                                                value={emissionDateEnd}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setEmissionDateEnd(event)} 
                                                intervalo={true}
                                                inicial={false}
                                                startDate={emissionDateIni} />
                                            </div>
                                          </div>
                                        </div>

                                        <div style={(width < 1030) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                          : {display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>

                                          <b>Data Lançamento</b>
                                          <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveReleaseDateIni"
                                                description="Inicial"
                                                value={releaseDateIni}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setReleaseDateIni(event)} 
                                                intervalo={true}
                                                inicial={true}
                                                endDate={releaseDateEnd} />
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                                marginTop: 10, minWidth: 25}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                                marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                              <label style={{fontWeight: 600}}>à</label>
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveReleaseDateEnd"
                                                description="Final"
                                                value={releaseDateEnd}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setReleaseDateEnd(event)} 
                                                intervalo={true}
                                                inicial={false}
                                                startDate={releaseDateIni} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}}>
                                        <b>Data Vencimento</b>
                                        <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                          <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateIni"
                                              description="Inicial"
                                              value={dueDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={dueDateEnd} />
                                          </div>

                                          <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                              marginTop: 10, minWidth: 25}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                              marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateEnd"
                                              description="Final"
                                              value={dueDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={dueDateIni} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  { showMenu && (width > 1380) &&
                                    <div style={{display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1}}>
                                        <b>Data Emissão</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveEmissionDateIni"
                                              description="Inicial"
                                              value={emissionDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setEmissionDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={emissionDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 20, 
                                            minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveEmissionDateEnd"
                                              description="Final"
                                              value={emissionDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setEmissionDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={emissionDateIni} />
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>
                                        <b>Data Lançamento</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveReleaseDateIni"
                                              description="Inicial"
                                              value={releaseDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setReleaseDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={releaseDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 20, 
                                            minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveReleaseDateEnd"
                                              description="Final"
                                              value={releaseDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setReleaseDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={releaseDateIni} />
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>
                                        <b>Data Vencimento</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateIni"
                                              description="Inicial"
                                              value={dueDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={dueDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 20, 
                                            minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateEnd"
                                              description="Final"
                                              value={dueDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={dueDateIni} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  { !showMenu && (width <= 1090) &&
                                    <div style={{display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}}>
                                      <div style={
                                        (width < 740) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                        : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                        <div style={(width < 740) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                          : {display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1}}>

                                          <b>Data Emissão</b>
                                          <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveEmissionDateIni"
                                                description="Inicial"
                                                value={emissionDateIni}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setEmissionDateIni(event)} 
                                                intervalo={true}
                                                inicial={true}
                                                endDate={emissionDateEnd} />
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                                marginTop: 10, minWidth: 25}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                                marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                              <label style={{fontWeight: 600}}>à</label>
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveEmissionDateEnd"
                                                description="Final"
                                                value={emissionDateEnd}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setEmissionDateEnd(event)} 
                                                intervalo={true}
                                                inicial={false}
                                                startDate={emissionDateIni} />
                                            </div>
                                          </div>
                                        </div>

                                        <div style={(width < 740) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                                          : {display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>

                                          <b>Data Lançamento</b>
                                          <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveReleaseDateIni"
                                                description="Inicial"
                                                value={releaseDateIni}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setReleaseDateIni(event)} 
                                                intervalo={true}
                                                inicial={true}
                                                endDate={releaseDateEnd} />
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                                marginTop: 10, minWidth: 25}
                                              : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                                marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                              <label style={{fontWeight: 600}}>à</label>
                                            </div>

                                            <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                              : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                              <DataPicker
                                                name="bordereauReceiveReleaseDateEnd"
                                                description="Final"
                                                value={releaseDateEnd}
                                                require={false}
                                                onSelect={setFieldSelected}
                                                onChange={(event) => setReleaseDateEnd(event)} 
                                                intervalo={true}
                                                inicial={false}
                                                startDate={releaseDateIni} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}}>
                                        <b>Data Vencimento</b>
                                        <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                                          : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                                          <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateIni"
                                              description="Inicial"
                                              value={dueDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={dueDateEnd} />
                                          </div>

                                          <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", 
                                              marginTop: 10, minWidth: 25}
                                            : {display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center", 
                                              marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={(width < 450) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateEnd"
                                              description="Final"
                                              value={dueDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={dueDateIni} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  { !showMenu && (width > 1090) &&
                                    <div style={{display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1}}>
                                        <b>Data Emissão</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveEmissionDateIni"
                                              description="Inicial"
                                              value={emissionDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setEmissionDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={emissionDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexDirection: "row", flexGrow: 0, justifyContent: "center", alignItems: "center",
                                            marginTop: 20, minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveEmissionDateEnd"
                                              description="Final"
                                              value={emissionDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setEmissionDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={emissionDateIni} />
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>
                                        <b>Data Lançamento</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveReleaseDateIni"
                                              description="Inicial"
                                              value={releaseDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setReleaseDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={releaseDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 20,
                                            minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveReleaseDateEnd"
                                              description="Final"
                                              value={releaseDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setReleaseDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={releaseDateIni} />
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>
                                        <b>Data Vencimento</b>
                                        <div style={{display: "flex", flexDirection: "row", flexGrow: 0}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateIni"
                                              description="Inicial"
                                              value={dueDateIni}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateIni(event)} 
                                              intervalo={true}
                                              inicial={true}
                                              endDate={dueDateEnd} />
                                          </div>

                                          <div style={{display: "flex", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 20, 
                                            minWidth: 25, maxWidth: 25}}>
                                            <label style={{fontWeight: 600}}>à</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}}>
                                            <DataPicker
                                              name="bordereauReceiveDueDateEnd"
                                              description="Final"
                                              value={dueDateEnd}
                                              require={false}
                                              onSelect={setFieldSelected}
                                              onChange={(event) => setDueDateEnd(event)} 
                                              intervalo={true}
                                              inicial={false}
                                              startDate={dueDateIni} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  <BillReceiveBordereau
                                    databaseType={databaseType}
                                    databasePath={databasePath}
                                    jsonCompany={jsonCompany}
                                    jsonLogin={jsonLogin}
                                    system={system}
                                    jBillReceive={jBillReceive}
                                    saveBillReceive={saveBillReceive}
                                    reverseBillReceive={() => alert("")}
                                    returnBordereau={returnAdd} 
                                    newBordereau={true} 
                                    height={height}
                                    width={width}
                                    showMenu={showMenu} />
                                </div>
                              </div>
                            </div>
                          }

                          { showAccountPlanSearch &&
                            <div>
                              <div style={{marginTop: 10, marginBottom: 10, marginLeft: 10}}>
                                <b>Selecione a plano de conta:</b>
                              </div>

                              <SearchAccountPlan
                                modeSearch={true}
                                databaseType={databaseType}
                                databasePath={databasePath}
                                jsonCompany={jsonCompany}
                                jsonLogin={jsonLogin}
                                system={system}
                                setAdd={() => alert("")}
                                setSelected={fillAccountPlan}
                                setReturn={() => setShowAccountPlanSearch(false)}
                                type={98} 
                                periodic={1} 
                                showMenu={showMenu}
                                width={width} />
                            </div>
                          }

                          { showAccount &&
                            <div>
                              <div style={{marginTop: 10, marginBottom: 10, marginLeft: 10}}>
                                <b>Selecione a conta:</b>
                              </div>

                              <SearchAccount
                                modeSearch={true}
                                databaseType={databaseType}
                                databasePath={databasePath}
                                jsonCompany={jsonCompany}
                                jsonLogin={jsonLogin}
                                system={system}
                                setAdd={() => alert("")}
                                setSelected={fillAccount} 
                                setReturn={() => setShowAccount(false)} 
                                showMenu={showMenu}
                                width={width} />
                            </div>
                          }
                          
                        </div>
                    }

                  </div>
                }

              </div>
          }

        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default BordereauReceive